module.exports = __webpack_public_path__ + "static/media/sreenu.eecbf16d.jpeg";